import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Spinner, IconButton } from '@mssgme/ui';
import { DeprecatedPlusIcon } from '@mssgme/icons';

import useHandleError from './useHandleError';

import styles from './AttachFile.scss';

AttachFile.propTypes = {
    isFetching: PropTypes.bool,
    error: PropTypes.string,
};

AttachFile.defaultProps = {
    isFetching: false,
};

export default function AttachFile({ isFetching, error, ...rest }) {
    const { t } = useTranslation('inbox');
    useHandleError(error);

    return (
        <IconButton className={styles.root} as="label" disabled={isFetching}>
            {/* TODO: use reset. Key is temporary solution */}
            <input key={String(isFetching)} name="attachment" type="file" {...rest} />
            {isFetching ? <Spinner size={22} /> : <DeprecatedPlusIcon size={16} title={t('AttachFileButton.tip')} />}
        </IconButton>
    );
}
